export default __webpack_public_path__ + "images/CW.39f6a6b.png";